export default __webpack_public_path__ + "static/media/login.f2e7d7bd.png";